angular
	.module 'App.Directive'
	.directive 'matchValueValidator', () ->
		restrict: 'A'
		require: ['ngModel', '^form']
		link: (scope, elem, attrs, controllers) ->
			currentController = controllers[0]
			ngForm = controllers[1]

			getOtherController = => ngForm[attrs.matchValueValidator]

			currentController.$validators.matchValue = (modelValue, viewValue) ->
				otherController = getOtherController()

				if (!otherController?)
					return true

				return viewValue == otherController.$viewValue

			scope.$watch(
				=> getOtherController()?.$viewValue,
				=> currentController.$validate()
			)
